module.exports = __webpack_public_path__ + "static/hero-image-cf8264b51dc3e6612556e6d224507d40.png";